export default __webpack_public_path__ + "static/media/sostenibilidad.4b0d7662.png";